export const fastlinks = [
  {
    name: 'Волна',
    id: '2303300001000',
    relation: '2300000000000',
    region: 'Краснодарский край',
  },
  {
    name: 'Новороссийск',
    id: '2300000600000',
    relation: '2300000000000',
    region: 'Краснодарский край',
  },
]

export const blocks = [
  ['by_distance', 'by_kladr'],
  ['bids_by_distance', 'bids_by_kladr'],
]

export const results = {
  by_distance: {
    title: 'Зерновозы по расстоянию',
    date: 'date_load',
    load: 'region_load_text',
    unload: 'region_unload_text',
    lat: 'lat',
    lon: 'lon',
  },
  by_kladr: {
    title: 'Зерновозы по району',
    date: 'date_load',
    load: 'region_load_text',
    unload: 'region_unload_text',
    lat: 'lat',
    lon: 'lon',
  },
  bids_by_distance: {
    title: 'Зерно по расстоянию',
    date: 'load_date',
    load: 'load_point',
    unload: 'unload_point',
    own: true,
    lat: 'load_coords_lat',
    lon: 'load_coords_lon',
  },
  bids_by_kladr: {
    title: 'Зерно по району',
    date: 'load_date',
    load: 'load_point',
    unload: 'unload_point',
    own: true,
    lat: 'load_coords_lat',
    lon: 'load_coords_lon',
  },
}
